import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Bundle, BundlesRepositoryService, ListComponent } from 'reg-hub-common';

@Component({
    selector: 'app-bundles-list',
    templateUrl: './bundles-list.component.html',
    styleUrl: './bundles-list.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BundlesListComponent extends ListComponent<Bundle> {

  displayedColumns: string[] = [
    'name',
    'description',
    'added'
  ];

  constructor(
      repo: BundlesRepositoryService) {
      super(repo);
    }
  
    ngOnInit(): void {
  
    }
}
